<template>
  <v-card class="change-email-modal">
    <v-card-title>{{ $t('my_account.change_email_title') }}</v-card-title>
    <v-card-text class="pa-2">
      <v-form ref="form">
        <v-row>
          <v-col>
            <v-text-field outlined
                          :label="$t('register.email')"
                          v-model="email"
                          clearable
                          :rules="emailRules"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field outlined
                          :label="$t('my_account.change_email_otp')"
                          v-model="otp"
                          clearable
                          :rules="requiredRules"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-btn block
                   x-large
                   color="primary"
                   @click="getOtp"
                   :disabled="!email || resendAfterSeconds > 0">
              {{ resendAfterSeconds > 0 ? $t('my_account.change_email_otp_resend_countdown', {second: resendAfterSeconds}) : $t('my_account.change_email_send_otp') }}
            </v-btn>
          </v-col>
        </v-row>

      </v-form>
    </v-card-text>
    <v-card-actions class="text-right">
      <v-btn @click="$emit('submit', undefined)"
             class="mr-3"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>

      <v-btn color="primary"
             class="ml-4"
             depressed
             large
             @click="$refs.form.validate() && submit()">
        {{ $t('submit') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {computed, onMounted, ref, watch} from '@vue/composition-api';
import BGModal from "@/components/BGModal";
import {DateTime} from "luxon";

export default {
  name: 'HkiaraceChangeEmailModal',
  components: {BGModal},
  props: {},
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const email = ref(null);
    const emailRules = ref([
      value => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || root.$t('register.invalid_email'),
    ]);
    const otp = ref(null);
    const resendAfter = ref(null);
    const resendAfterSeconds = ref(0);
    const resendCountdownInterval = ref(null);
    const getOtp = async function () {
      root.$callAPI('hkiarace/get_otp/',{
        email: email.value,
      }, (response) => {
        if (response.body.success) {
          resendAfter.value = DateTime.fromISO(response.body.resend_after);
          resendCountdownInterval.value = setInterval(() => {
            resendAfterSeconds.value = Math.ceil(resendAfter.value.diffNow('seconds').seconds);
            if (resendAfterSeconds.value === 0) {
              clearInterval(resendCountdownInterval.value);
              resendCountdownInterval.value = null;
            }
          }, 1000);
        }
      });
    }

    const submit = function () {
      root.$callAPI('hkiarace/change_email/',{
        email: email.value,
        otp: otp.value,
      }, (response) => {
        if (response.body.success) {
          emit('submit', true);
        }
      });
    }


    return {
      requiredRules,

      email,
      emailRules,
      otp,
      resendAfterSeconds,
      getOtp,
      submit,
    }
  },
}
</script>

<style lang="less">
.validate-sasv-modal {
  display: flex !important;
  flex-direction: column !important;
  height: 90vh;
  overflow: hidden;

  .v-card__text {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    width: 100% !important;
  }
}
</style>
